import { createClient }from "@sanity/client";

export default createClient({
  projectId: "40t4ruzv",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-02-01"
  
});